<template>
  <div class="messagesContent message" style="justify-content: center">
    <span v-if="source.user_name != ''">
      <span
        class="mr-1 message-sent-at"
        style="display: inline-block; width: 34px"
        >{{ source.sent_at }}
      </span>
      <span
        class="you-message"
        v-if="source.user_name === 'Você' || source.user_name === 'You'"
        >{{ source.user_name }}</span
      >
      <span
        v-if="
          source.user_name !== 'Você' &&
          source.user_name !== 'You' &&
          !source.typedMessage
        "
        class="received-user-name"
        :class="{ 'admin-message': source.is_admin }"
        >{{ source.user_name }}</span
      >

      <span class="ml-1 chat-message">
        {{ source.text }}
      </span>
    </span>
    <span style="display: flex" v-else>
      <span class="system-message">{{ source.text }}</span>
    </span>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-icon
          v-if="source.user_name != ''"
          style="font-size: 19px; margin-left: auto"
          class="send-icon"
          color="primary"
          v-on="on"
          @click="selectUser(source.user)"
        >
          mdi-dots-vertical
        </v-icon>
      </template>
      <v-list>
        <v-list-item @click="removeMessage(source)">
          <v-list-item-title
            style="font-size: 14px; font-weight: 400; line-height: 21px"
            >{{
              $t('message.pages.live.chat.deleteComment')
            }}</v-list-item-title
          >
        </v-list-item>
        <v-divider
          v-if="source.user_name != 'Você' && source.user_name != 'You'"
        />
        <v-list-item
          v-if="source.user_name != 'Você' && source.user_name != 'You'"
          @click="removeUserFromChatMessage(source)"
        >
          <v-list-item-title style="color: red; font-size: 14px"
            >{{ $t('message.pages.live.chat.blockUser') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'item',
  props: {
    source: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    selectUser(user) {
      this.$root.$emit('selectUser', user)
    },
    removeMessage(source) {
      this.$root.$emit('removeMessage', source)
    },
    removeUserFromChatMessage(source) {
      this.$root.$emit('removeUserFromChatMessage', source)
    },
  },
}
</script>

<style lang="scss" scoped>
.you-message {
  font-weight: 500;
  border-radius: 2px;
  padding: 0px 4px 0px 4px;
  color: #f8f8ff;
  background-color: var(--v-primary-base);
}

.received-user-name {
  font-weight: 500;
  color: var(--v-neutral-lighten1);
}

.chat-message {
  color: var(--v-neutral-lighten1);
}

.v-btn {
  letter-spacing: 0;
  text-transform: none;
}

.chat__message {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  min-height: 100px;
}
.text-message {
  flex-grow: 1;
}

.system-message {
  font-style: italic;
  justify-content: center;
}

.messagesContent {
  display: inline-flex;
  grid-template-rows: auto 1fr auto;
  width: 100%;
  grid-template-columns: 2;
  font-size: 14px;
  color: var(--v-neutral-lighten1);

  .options {
    padding-top: 10px;
    text-align: center;
    border-bottom: 1px solid var(--v-neutral-lighten3);

    span {
      cursor: pointer;
      margin-right: 20px;
      transition: color 0.3s ease;
      padding-bottom: 11px;

      &.selected {
        color: var(--v-brand-base);
        font-weight: 500;
        margin-bottom: 10px;
      }
    }
  }

  &::v-deep {
    @import '@/assets/scss/src/new-live';
  }
}

.admin-message {
  font-weight: 500;
  color: red;
}

.message-sent-at {
  color: var(--v-neutral-lighten2);
  font-size: 12px;
}

.message {
  border-radius: 4px;
  padding: 5px;
  padding-bottom: 2px;
  margin-bottom: 8px;
  padding-top: 2px;
  font-size: 14px;
  word-break: break-word;
  white-space: pre-wrap;
  position: relative;

  &:hover .send-icon {
    opacity: 1;
  }

  .send-icon {
    font-size: 19px;
    color: primary;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
}

.v-icon.v-icon::after {
  background-color: transparent;
}

.message:hover {
  background-color: #e8eafd;
  .chat-message {
    color: #232536;
  }
  .message-sent-at {
    color: #232536;
  }
}

.dots-icon {
  cursor: pointer;
  font-size: 19px;
  margin-left: auto;
  color: var(--v-primary-base);
  opacity: 0;
  margin-right: 20px;
}

.text-message .v-input__control {
  height: 70px;
}

.send-icon:hover {
  cursor: pointer;
}

.bg-dark {
  .options {
    border-bottom: 1px solid #72727272;
  }

  .messagesContent {
    background-color: var(--v-neutral-darken2);
    color: white;
  }
  .modal {
    background-color: var(--v-neutral-darken2);
  }
  .userInitials {
    background-color: var(--v-primary-base);
  }

  .received-user-name {
    color: var(--v-brand-lighten1);
  }

  .options {
    span {
      cursor: pointer;
      margin-right: 20px;
      transition: color 0.3s ease;
      padding-bottom: 11px;

      &.selected {
        color: var(--v-primary-base);
        font-weight: 500;
        margin-bottom: 10px;
      }
    }
  }

  .chat-message {
    color: var(--v-brand-lighten1);
  }

  .you-message {
    background-color: #0f21a1;
  }

  .message-sent-at {
    color: #515570;
  }

  .message:hover {
    background-color: #373b54;
    .chat-message {
      color: var(--v-brand-lighten2);
    }
    .message-sent-at {
      color: var(--v-brand-lighten2);
    }
  }
}
</style>
